import { TmdxAvatar, Tooltip } from '@ds';
import { ConditionalRender } from '@ui';
import SectionRow from '@features/components/CaseOverview/components/SectionRow/SectionRow';
import { AssignedUser } from '@/api/apis/case';
import { getFullName } from '@/utils/helpers';

type Props = {
  coordinator?: AssignedUser | undefined;
  txCenterId?: string | null;
};

export const TXCenterCoordinatorInfo = ({ coordinator, txCenterId }: Props) => {
  const fullName = getFullName(coordinator?.user?.firstName, coordinator?.user?.lastName);
  const isServiceWithoutCoordinator = () => {
    if (txCenterId) {
      return (
        <div className="flex gap-2 items-center">
          <TmdxAvatar size="lg" radius="md" name="" type="user" src="" fallbackInitials />
          <Tooltip className="text-m-r!" content="Service without TX Center coordinator" showArrow>
            <span className="truncate min-w-0"> Service without TX Center coordinator</span>
          </Tooltip>
        </div>
      );
    }
    return '-';
  };

  return (
    <SectionRow label="TX Center Coordinator">
      <ConditionalRender show>
        {coordinator ? (
          <div className="flex gap-2 items-center">
            <TmdxAvatar
              size="lg"
              radius="md"
              name={fullName || ''}
              type="user"
              src={coordinator.user?.photoPath}
              fallbackInitials
            />
            <Tooltip
              className="text-m-r!"
              content={`${coordinator.user?.firstName ?? ''} ${coordinator.user?.lastName ?? ''}`}
              showArrow
            >
              <span className="truncate min-w-0">
                {coordinator.user?.firstName} {coordinator.user?.lastName}
              </span>
            </Tooltip>
          </div>
        ) : (
          isServiceWithoutCoordinator()
        )}
      </ConditionalRender>
    </SectionRow>
  );
};
